<section class="relevant-article-section">
  <div class="container">
    <h2 class="section-title">Relevant Article</h2>

    <div class="row g-4 justify-content-center">
      <!-- Loop through the 3 random whitepapers -->
      <div class="col-lg-4 col-md-6" *ngFor="let paper of relevantWhitepapers">
        
        <!-- The entire card is a clickable link -->
        <div class="article-card" (click)="navigateTo(paper.route)">
          <img [src]="paper.image" [alt]="paper.title" class="card-image">
          <div class="card-content">
            <h5 class="card-title">{{ paper.title }}</h5>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>